import { Updater } from 'widgets-for-react'
import { fieldUpdater } from '../../../../utils/updaters'
import { BlogTeasersState } from '../../blogs/blogTeasers/blogTeasersState'
import { ComponentTeasersState } from '../../components/componentTeasers/componentTeasersState'
import { ImageData } from '../../image/imageState'
import { HomeData } from '../home.state'

export type ExtendedLoggedOutHomeState = LoggedOutHomeState & {
  homeDataUpdater?: Updater<HomeData>
}

export type LoggedOutHomeState = {
  videoOpened: boolean
  quoteCarouselData: SlideImageData[]
}

export type SlideImageData = {
  imageData: ImageData
} & { SrcSet: string; Id: number }

export const initialLoggedOutHomeState: LoggedOutHomeState = {
  videoOpened: false,
  quoteCarouselData: [],
}

export const loggedOutHomeStateUpdaters = {
  updateQuoteCarouselData:
    (data: SlideImageData[]) =>
    (currentState: LoggedOutHomeState): LoggedOutHomeState => ({
      ...currentState,
      quoteCarouselData: data,
    }),
  updateVideoOpened:
    (videoOpened: boolean) =>
    (currentState: LoggedOutHomeState): LoggedOutHomeState => ({
      ...currentState,
      videoOpened: videoOpened,
    }),
  updateBlogTeasersDataState:
    (updater: Updater<BlogTeasersState>) =>
    (state: LoggedOutHomeState): ExtendedLoggedOutHomeState => ({
      ...state,
      homeDataUpdater: fieldUpdater<HomeData>()('blogTeasers')(updater),
    }),
  updateComponentTeasers:
    (updater: Updater<ComponentTeasersState>) =>
    (state: LoggedOutHomeState): ExtendedLoggedOutHomeState => ({
      ...state,
      homeDataUpdater: fieldUpdater<HomeData>()('componentTeasers')(updater),
    }),
}
